module.exports = __webpack_public_path__ + "img/plyr.3a727a9b.svg";